var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.users && _vm.users.length)?_c('v-card',{staticClass:"mt-16",attrs:{"outlined":""}},[_c('v-card-title',[_vm._v(" Preautorizzazioni non andate a buon fine ")]),_c('v-card-text',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.users,"sort-by":"name","items-per-page":-1,"hide-default-footer":""}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }